<div class="default-header-container">
  <lcp-header [isInverted]="true"></lcp-header>
</div>

<div class="default-banner-container">
  <ss-banner 
    [src]="fields.banner_src"
    [imageID]="fields.banner_id"
    [imageAR]="fields.banner_ar"
    class="fill-container">

    <div class="default-banner-content">
      <h1 *ngIf="fields.banner_text"
        class="color-white">
        {{ fields.banner_text }}
      </h1>

      <div *ngIf="fields.banner_button_text"
        class="default-banner-button-container">
        <a class="btn-secondary"
          [routerLink]="fields.banner_button_path">
          {{ fields.banner_button_text }}
        </a>
      </div>
    </div>
  </ss-banner>
</div>

<div class="default-container-wrapper">
  <div class="default-container-outer"
    [class.without-banner-text]="!fields.banner_text">
    <div class="default-container-inner">
      <!-- [class.opacity-0]="!isPopulated"> -->

      <div class="default-content"
        [ngClass]="contentClass">
        <!-- <h1 class="default-heading">welcome</h1>
        -->
        <ng-content></ng-content>

        <div #bottomContainer></div>
      </div>
    </div>
  </div>
</div>

